import React from "react";
import "../Projects/Projects.scss";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiTrash2 } from "react-icons/fi";
import { DeleteProjectPopup } from "../DeleteProjectPopup/DeleteProjectPopup";
//import moment from "moment";
import {
  HiOutlineArrowNarrowUp,
  HiOutlineArrowNarrowDown,
} from "react-icons/hi";

export const Projects = () => {
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();
  const userToken = localStorage.getItem("userToken");
  const [showDeleteProjectPopup, setShowDeleteProjectPopup] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [IsPojectDeleted, setIsProjectDeleted] = useState(false);

  const [searchProject, setSearchProject] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const dateKeys = ["project_start", "project_end"];

  const filteredProjects = projects
    .filter((project) => {
      const term = searchProject.toLowerCase();
      return (
        project.project_name?.toLowerCase().includes(term) ||
        project.project_id?.toString().includes(term) ||
        project.project_code?.toLowerCase().includes(term)
      );
    })
    .sort((a, b) => {
      if (!sortConfig.key) return 0;

      let valA = a[sortConfig.key];
      let valB = b[sortConfig.key];

      if (dateKeys.includes(sortConfig.key)) {
        valA = new Date(valA);
        valB = new Date(valB);

        // Ako je Invalid Date, postavi na neku default vrednost
        if (isNaN(valA)) valA = new Date(0);
        if (isNaN(valB)) valB = new Date(0);
      }

      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

  const fetchProjects = async () => {
    try {
      const response = await fetch(
        "https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/projects-select_w.php",
        {
          method: "GET",
          headers: {
            Token: userToken,
          },
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        if (data.response) {
          setProjects(data.data);
        } else {
          console.error(data.message);
        }
      } else {
        throw new Error("Server je vratio status: " + response.status);
      }
    } catch (error) {
      console.error(
        "Došlo je do greške prilikom slanja zahteva na server:",
        error
      );
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [userToken, IsPojectDeleted]);

  const handleDeleteProject = async (project_id) => {
    try {
      console.log("Deleting project with ID:", project_id);

      const response = await fetch(
        "https://ciricgmbh-dokumentation.de/ciric-doku-api/a/cd/w/project-delete_w.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Token: userToken,
          },
          body: JSON.stringify({ project_id }),
        }
      );

      console.log("Server response:", response);
      const responseText = await response.text();
      console.log("Server response text:", responseText);

      if (response.status === 200) {
        const data = await response.json();
        console.log("Response data:", data);

        if (data.response) {
          console.log("Uspešno obrisan projekat.");
        } else {
          console.error("Neuspešno brisanje projekta.");
        }
      } else {
        console.error(
          `Došlo je do greške prilikom brisanja projekta. Status kod: ${response.status}`
        );
      }
    } catch (error) {
      console.error("Došlo je do greške prilikom slanja zahteva:", error);
    }
    fetchProjects();
  };
  console.log("selectedProjectId:", selectedProjectId);

  return (
    <div className="projects">
      <h3>List of projects</h3>
      <div className="projects-filter">
      <input
          type="text"
          placeholder="Search..."
          value={searchProject}
          onChange={(e) => setSearchProject(e.target.value)}
        />
      </div><br/>
      <div className="table-form">
        <table>
          <thead>
            <tr>
              {[
                { label: "ID", key: "project_id" },
                { label: "NAME", key: "project_name" },
                { label: "PROJEKTNUMMER", key: "project_code" },
                { label: "PROJEKTSTART", key: "project_start" },
                { label: "PROJEKTENDE", key: "project_end" },
                { label: "PLZ", key: "zip_code" },
                { label: "STADT", key: "city" },
                { label: "STRAßE", key: "street" },
                { label: "STAAT", key: "country" },
              ].map(({ label, key }) => (
                <th key={key}>
                  {label}
                  <span className="sort-icons">
                    <HiOutlineArrowNarrowUp
                      className="sort-icon"
                      onClick={() => handleSort(key, "asc")}
                      style={{
                        cursor: "pointer",
                        color:
                          sortConfig.key === key &&
                          sortConfig.direction === "asc"
                            ? "#999"
                            : "#fff",
                        transform:
                          sortConfig.key === key &&
                          sortConfig.direction === "asc"
                            ? "scale(1.2)"
                            : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                    <HiOutlineArrowNarrowDown
                      className="sort-icon"
                      onClick={() => handleSort(key, "desc")}
                      style={{
                        cursor: "pointer",
                        color:
                          sortConfig.key === key &&
                          sortConfig.direction === "desc"
                            ? "#999" // aktivna strelica postaje siva
                            : "#fff", // default bela
                        transform:
                          sortConfig.key === key &&
                          sortConfig.direction === "desc"
                            ? "scale(1.2)"
                            : "scale(1)",
                        transition: "all 0.2s ease",
                      }}
                    />
                  </span>
                </th>
              ))}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredProjects.length === 0 ? (
              <tr>
                <td colSpan="12">No projects available</td>
              </tr>
            ) : (
              filteredProjects.map((project) => (
                <tr
                  key={project.project_id}
                  onClick={() =>
                    navigate(
                      `/homePage/editProject?project_id=${project.project_id}`,
                      {
                        state: {
                          delete: 0,
                          projectName: project.project_name,
                        },
                      }
                    )
                  }
                >
                  <td>{project.project_id}</td>
                  <td>{project.project_name}</td>
                  <td>{project.project_code}</td>
                  <td>{project.project_start}</td>
                  <td>{project.project_end}</td>
                  <td>{project.zip_code}</td>
                  <td>{project.city}</td>
                  <td>{project.street}</td>
                  <td>{project.country}</td>
                  <td>
                    <FiTrash2
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDeleteProjectPopup(true);
                        setSelectedProjectId(project.project_id);
                      }}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {showDeleteProjectPopup && (
          <DeleteProjectPopup
            show={showDeleteProjectPopup}
            onHide={() => setShowDeleteProjectPopup(false)}
            onDelete={() => {
              handleDeleteProject(selectedProjectId);
              setShowDeleteProjectPopup(false);
              setIsProjectDeleted(true);
            }}
          />
        )}
      </div>
    </div>
  );
};
